

<div class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
          <button mat-icon-button class="mr-16" [routerLink]="'/settings'">
              <mat-icon>arrow_back</mat-icon>
          </button>
            <h2 class="m-0">{{'CONFIGURACION.BD.TITUHEAD' | translate}}</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">

            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <span>{{'CONFIGURACION.BD.INFO' | translate}}</span>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" fusePerfectScrollbar >

              <div id="cards" class="page-layout simple fullwidth" align="center">

                  <div class="fuse-card" style="height: 10%; width: 30%; margin: 10px;">
                      <div class="pt-8 pb-30" fxLayout="column" fxLayoutAlign="center center">
                          <button mat-raised-button color="accent" style="width: 90%;">{{'CONFIGURACION.BD.BOTONES.DescTemp' | translate}}</button>
                      </div>
                  </div>
                  <div class="message-box">
                      {{'CONFIGURACION.BD.MENSAJES.CARGABD' | translate}}
                  </div>
                  <hr>
                  <span class="mat-display-1">{{'CONFIGURACION.BD.MENSAJES.STATUS' | translate}}</span>
                  <div class="message-box error">
                      {{'CONFIGURACION.BD.MENSAJES.ERROR' | translate}}
                  </div>
                  <div class="message-box success">
                      {{'CONFIGURACION.BD.MENSAJES.CORRECTO' | translate}}
                  </div>
              </div>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
